import { Popover } from "@base-ui-components/react";

export namespace PopoverTrigger {
	export type ElementName = "Popover.Trigger";
	export type ElementType = HTMLElement;
	export type Props = Popover.Trigger.Props;
}

export const PopoverTrigger = (componentProps: PopoverTrigger.Props) => {
	const { children, ...restProps } = componentProps;

	return <Popover.Trigger {...restProps}>{children}</Popover.Trigger>;
};
